import { createPinia } from 'pinia'
import { type App } from 'vue'

/**
 * Installs Pinia plugin into the provided Vue app.
 * This, as a hook, allows for us to register custom Pinia plugins
 * without polluting main.ts.
 *
 * @param {import('vue').App<Element>} app - The Vue app instance.
 * @param piniaUse Plugins to register w/ Pinia
 */
export const installPinia = (app: App<Element>, piniaUse: any[] = []) => {
  const pinia = createPinia()
  piniaUse.forEach(use => pinia.use(use))
  app.use(pinia)
}
